import { OfferDto } from "@intelligems/ig-types";

export const hasFreeShipping = (offer?: OfferDto): boolean => {
  return offer?.tiers?.some((t) => t.isFreeShipping) || false;
};

export const hasGiftWithPurchase = (offer?: OfferDto): boolean => {
  return offer?.tiers?.some((t) => t.isGiftWithPurchase) || false;
};
